module.exports = __webpack_public_path__ + "static/kart-on-ice-6678f50f82c888da3e7ff731c613619d.jpg";